<script setup>
import { CollapsibleContent } from 'radix-vue'

const props = defineProps({
    forceMount: { type: Boolean, required: false },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
})
</script>

<template>
    <CollapsibleContent
        v-bind="props"
        class="overflow-hidden transition-all data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down"
    >
        <slot />
    </CollapsibleContent>
</template>
